<template>
<div class="detail-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-cell-group>
		    <van-cell class="detail-title">
		        <h2>{{new_details.post_title}}</h2>
				<p class="attrs">
					<span class="c999 mt5 left pl20">行业新闻</span>
					<span class="c999 mt5 pr20 right">{{new_details.post_date.substr(0,10)}}</span>
				</p>
		    </van-cell>
		    <van-cell class="detail-content">
		        <pre v-html="new_details.post_content"></pre>
		    </van-cell>
		 </van-cell-group>
<!--		 <FooterNews></FooterNews> &lt;!&ndash; 尾部 &ndash;&gt;-->
	</div>
</div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
	var $rus=this.$router.history;
	this.nid=$rus["current"].query.nid;
	this.getNewsDetail();	
  },
  mounted(){
	  this.watermark.set(this.ADMIN.USER_NAME+"_"+this.ADMIN.USER_CODE); //水印
	  //滚动
	  window.addEventListener('scroll', function(){
		  $(".detail-page .detail-title").addClass("fixedtitle");
		  $(".detail-page .detail-content").css("margin-top",$(".detail-page .detail-title").height());
	  }, true);
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  nid:0,
	  new_details: [],
	};
   },
   filters: {
    },
    methods: {
	   getNewsDetail: function () {
		 axios.get(this.CoreNew.CECPORT_URL+"icapi/getNewsDetail/", { 
	     	params: {nid:this.nid}
	     }).then(function (response) {
			if(response.data.status==1){
				var $rs=response.data;
				this.new_details=$rs.lists;
			}
	     }.bind(this)).catch(function (error) { 
	     	//alert("请求--新闻详细页--失败"+error);
			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--新闻详细页--失败"+error);//记录错误
	     	console.log("请求--新闻详细页--失败"+error); 
	     });
	   }
    }
};
</script>
